import React, { useEffect, useRef, useState } from 'react';
import { showErrorToast, showInfoToast } from '../../../utils/toastHelper';
import { useTranslation } from 'react-i18next';
import {
  exportCustomerGroups,
  exportCustomers,
} from '../services/customersService';
import FileNames from '../../../constants/fileNames';
import { isValidImportFileName } from '../../../utils/commonUtils';

export default function ImportCustomersModal({
  isOpen,
  onClose,
  handleImportCustomers,
  importLoading,
  customerCategory,
  sample,
}) {
  const modalRef = useRef(null);
  const modalInstanceRef = useRef(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(null);
  const [importedData, setImportedData] = useState(null);
  const [customerCategoryId, setCustomerCategoryId] = useState(null);
  const [sampleFileName, setSampleFileName] = useState('Sample_Import.xlsx');
  // const [exportFileName, setExportFileName] = useState('');
  const fileInputRef = useRef(null);
  const { t } = useTranslation('Customer');
  const { t: importT } = useTranslation('Import');
  const fileNameMap = {
    catering: {
      customerGroups: {
        sampleName: FileNames.CATERING_CUSTOMER_GROUPS_SAMPLE,
        exportName: FileNames.CATERING_CUSTOMER_GROUPS_EXPORT,
      },
      customers: {
        sampleName: FileNames.CATERING_CUSTOMERS_SAMPLE,
        exportName: FileNames.CATERING_CUSTOMERS_EXPORT,
      },
    },
    fbz: {
      customerGroups: {
        sampleName: FileNames.FBZ_CUSTOMER_GROUPS_SAMPLE,
        exportName: FileNames.FBZ_CUSTOMER_GROUPS_EXPORT,
      },
      customers: {
        sampleName: FileNames.FBZ_CUSTOMERS_SAMPLE,
        exportName: FileNames.FBZ_CUSTOMERS_EXPORT,
      },
    },
  };
  useEffect(() => {
    if (customerCategory?.id) {
      setCustomerCategoryId(customerCategory.id);
      const category = customerCategory.name.toLowerCase();

      const fileName = fileNameMap[category]?.[sample]?.sampleName;
      if (fileName) {
        setSampleFileName(fileName);
      }

      // const exportFileName = fileNameMap[category]?.[sample]?.exportName;
      // if (exportFileName) {
      //   setExportFileName(exportFileName);
      // }
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [customerCategory]);
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // const isValid = isValidImportFileName(selectedFile.name, [
      //   sampleFileName,
      //   exportFileName,
      // ]);
      // Check file type (CSV)
      if (
        !selectedFile.name.endsWith('.csv') &&
        !selectedFile.name.endsWith('.xlsx')
      ) {
        showErrorToast(importT('PLEASE_SELECT_VALID_FILE'));
        if (fileInputRef.current) {
          fileInputRef.current.value = ''; // Clear the file input
        }
        setFile(null);
        return;
      }

      if (selectedFile.size > 2 * 1024 * 1024) {
        // 2MB
        showErrorToast(importT('FILE_SIZE_EXCEEDS_LIMIT'));
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setFile(null);
        return;
      }
      setFile(selectedFile);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      showInfoToast(importT('PLEASE_SELECT_FILE_FIRST'));
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('customer_category_id', customerCategoryId);
    const response = await handleImportCustomers(formData);
    if (response.success) {
      setImportedData(response.import_progress);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setFile(null);
  };
  const handleDownloadSample = async () => {
    let response;
    if (sample === 'customerGroups') {
      response = await exportCustomerGroups({ sample: true }, sampleFileName);
    } else if (sample === 'customers') {
      response = await exportCustomers({ sample: true }, sampleFileName);
    }
  };
  useEffect(() => {
    modalInstanceRef.current = new window.bootstrap.Modal(modalRef.current, {
      backdrop: 'static',
      keyboard: false,
    });

    return () => {
      modalInstanceRef.current.dispose();
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      modalInstanceRef.current.show();
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } else {
      modalInstanceRef.current.hide();
    }
  }, [isOpen]);
  return (
    <div
      className="modal fade  import-file"
      id="import-customers"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
      ref={modalRef}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {importedData ? t('Import Details') : t('IMPORTFILE')}
            </h1>
            <button
              className="btn-close"
              onClick={() => {
                if (fileInputRef.current) {
                  fileInputRef.current.value = ''; // Clear the file input
                }
                setFile(null);
                setImportedData(null);
                onClose('import');
              }}
            ></button>
          </div>
          {importedData ? (
            <div className="modal-body">
              <div className="product-inner">
                <div className="import-status mt-3">
                  <h3 className="import-head">{t('IMPORTSTATUS')}</h3>
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <strong className="pe-2">{t('STATUS')}:</strong>{' '}
                        {t(importedData.status)}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong className="pe-2">{t('PROCESSEDROWS')}:</strong>{' '}
                        {importedData.processed_rows}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong className="pe-2">{t('SUCCESSFULROWS')}:</strong>{' '}
                        {importedData.success_rows}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong className="pe-2">{t('FAILEDROWS')}:</strong>{' '}
                        {importedData.failed_rows}
                      </p>
                    </div>
                  </div>

                  {importedData.error_message && (
                    <div className="errors">
                      <h4>{t('ERRORS')}:</h4>
                      <ul>
                        {importedData.error_message
                          .split(',')
                          .map((error, index) => (
                            <li key={index}>{error.trim()}</li>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => {
                    setImportedData(null);
                    onClose('import');
                  }}
                  className={`import-btn`}
                >
                  {t('CLOSE')}
                </button>
              </div>
            </div>
          ) : (
            <div className="modal-body">
              <div className="product-inner">
                <label>
                  <form action="">
                    <img src="images/file-download-import-icon 1.svg" alt="" />
                    <p>{t('UPLOADFILE')}...</p>
                    <input
                      ref={fileInputRef}
                      type="file"
                      name="file"
                      id="file"
                      onChange={handleFileChange}
                      accept=".xls,.xlsx,.csv"
                    />
                  </form>
                </label>
                {file && (
                  <div className="file-name-display mt-3">
                    <p>
                      <strong>{t('SELECTEDFILE')}:</strong> {file.name}
                    </p>
                  </div>
                )}
                <div className="file-name-display mt-3">
                  <p>
                    <button
                      className="btn btn-link"
                      onClick={handleDownloadSample}
                    >
                      {t('DOWNLOADSAMPLE')}
                    </button>
                  </p>
                </div>

                <div className="d-flex justify-content-between py-3 file-size">
                  <p className="mb-0">{t('SUPPORTEDFORMAT')}: xlsx</p>
                  <p className="mb-0">{t('MAXIMUMSIZE')}: 2MB</p>
                </div>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className={`import-btn mt-1 ${importLoading || loading ? 'disable-btn' : ''}`}
                  disabled={importLoading || loading}
                >
                  {importLoading ? t('IMPORTING') + '...' : t('IMPORT')}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
